import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — Resets window scroll to (0,0) on every route change so the
 * user always lands at the top of the new page. Honors hash (#section) by
 * scrolling that element into view instead.
 *
 * Mount once at the top of the app, inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for the target element to mount, then scroll it into view.
      const id = hash.replace(/^#/, "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      };
      // Defer one tick to allow the new route to render
      const t = setTimeout(tryScroll, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
